exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notifications-frequency[data-v-1f649917] {\n  padding: 0 2em;\n}\n.notifications-frequency .field[data-v-1f649917] {\n    padding-top: 1em;\n}\n", ""]);

// exports
